import cn from 'classnames'
import React, { ComponentProps, useId } from 'react'

type AlertCircleFilledIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function AlertCircleFilledIcon(
  props: AlertCircleFilledIconProps,
) {
  const { className = '', ...rest } = props
  const clipId = useId()
  return (
    <svg
      className={cn('AlertCircleFilledIcon', className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z"
          fill={props.fill || '#D5404A'}
        />
        <path
          d="M10.0001 6.66667V10M10.0001 13.3333H10.0084M18.3334 10C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 10C1.66675 5.39763 5.39771 1.66667 10.0001 1.66667C14.6025 1.66667 18.3334 5.39763 18.3334 10Z"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
